module.exports = __webpack_public_path__ + "static/media/media.bf0d6f4d.png";